/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import ApiEditForm from "./ApiEditForm";
import ApiCreateForm from "./ApiCreateForm";
import React from "react";

export default function ApiSelectedDetails({ selected, setSelected, activeTab = "API Details" }) {
  const [createApi, setCreateApi] = React.useState(false);
  if (!selected) {
    return (
      <div
        style={{
          width: "100%",
          height: "83vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span className="">Please select a hospital to view/edit APIs</span>
      </div>
    );
  }

  return (
    <div>
      {selected.api ? (
        <div style={{ width: "100%", height: "83vh", display: "flex", flexDirection: "column" }}>
          <div className="p-3 border-b flex items-center justify-between bg-muted/20">
            <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider ml-2">
              Configuration
            </h2>
          </div>
          <div style={{ flex: 1, overflow: "hidden" }}>
            <div className="border p-2" style={{ width: "100%", height: "100%", display: "flex" }}>
              <ApiEditForm selected={selected} setSelected={setSelected} />
            </div>
          </div>
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center gap-5"
          style={{ width: "100%", height: "83vh" }}
        >
          <span className="">This hospital has no API configured.</span>
          <Button className="ml-4" onClick={() => setCreateApi(true)}>
            Add API
          </Button>
        </div>
      )}

      <Sheet open={createApi} onOpenChange={setCreateApi}>
        <SheetContent className="w-full sm:w-full md:max-w-2xl overflow-y-auto">
          <SheetHeader>
            <SheetTitle>Create New API</SheetTitle>
            <SheetDescription>
              Configure API access and model permissions for{" "}
              {selected?.name || "this hospital"}
            </SheetDescription>
          </SheetHeader>
          <div className="mt-6">
            <ApiCreateForm setAddHospitalSheet={setCreateApi} />
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
